import athenaConfig from '../config';
import { ANET_USER_PREFIX_SUPPORT_ENV_MAP, APP_TYPES, FUZZY_ENV_MAPPING, NON_FUZZY_ANET_USER_DOMAIN } from '../constants';
import { getUsername } from './widget-facade';

export function isAnetUser() {
  const username = getUsername();
  return username?.includes(NON_FUZZY_ANET_USER_DOMAIN);
}

export function getAnetUsername() {
  return isAnetUser() ? getUsername().split('@')[0] : '';
}

export function getPatientUserNamespace() {
  const { supportEnv, appType } = global.settings;
  if (supportEnv && appType === APP_TYPES.PATIENT) {
    return FUZZY_ENV_MAPPING[supportEnv].userNamespace;
  }
}

export function getAnetDb(): string | undefined  {
  if (athenaConfig.featureFlags.enableAnetDbNamespace) {
    return new URLSearchParams(window.location.search).get('anet_db') || undefined;
  }
}

export function getAnetUserDomain(username: string) {
  const userPrefix = username.split('-')[0];
  const { supportEnv: appSupportEnv, appType } = global.settings;
  if (userPrefix) {
    const userSupportEnv = ANET_USER_PREFIX_SUPPORT_ENV_MAP[userPrefix];
    if (appSupportEnv && userSupportEnv === appSupportEnv && appType === APP_TYPES.ATHENANET_USER) {
      return FUZZY_ENV_MAPPING[appSupportEnv].anetUserDomain;
    }
  }
  if (appType === APP_TYPES.ATHENANET_USER) {
    if (athenaConfig.featureFlags.enableAnetDbNamespace) {
      const anetDb = getAnetDb();
      if (!anetDb && athenaConfig.defaultNamespace) {
        return `${athenaConfig.defaultNamespace}.${NON_FUZZY_ANET_USER_DOMAIN}`;
      }
      if (anetDb) {
        return `${anetDb}.${NON_FUZZY_ANET_USER_DOMAIN}`;
      }
    }
  }
  return NON_FUZZY_ANET_USER_DOMAIN;
}

export function transformUsername(username: string, _operation: string) {
  //non-anet users
  if (username.indexOf('@') > -1) {
    const patientUserNamespace = getPatientUserNamespace();
    if (patientUserNamespace && !username.endsWith(patientUserNamespace)) {
      return `${username}${patientUserNamespace}`;
    }
    return username;
  }
  else {
    return username + '@' + getAnetUserDomain(username);
  }
}

export function isSupportEnvUser() {
  const username = getUsername();
  const userPrefix = username.split('-')[0];
  return ANET_USER_PREFIX_SUPPORT_ENV_MAP[userPrefix];
}

export function isProdUserInSupport() {
  if (athenaConfig.shouldBlockPasswordUpdateForProdUser) {
    return !isSupportEnvUser();
  }
  return false;
}
